import React from 'react'
import App from 'next/app'
import Head from 'next/head'
import Router from 'next/router'
import { ToastContainer } from 'react-toastify'
import * as Sentry from '@sentry/node'
import { scrollTop } from 'utils'

import { RootProvider } from 'context/rootContext'
import DefaultLayout from 'components/layout/DefaultLayout'
import GlobalStyle from '../styles/global'
import 'react-toastify/dist/ReactToastify.min.css'
import { PaymentContextProvider } from 'src/context/paymentContext'
import { ServiceScheduleContextProvider } from 'src/context/serviceScheduleContext'

if (process.env.SENTRY_DSN) {
  Sentry.init({
    enabled: process.env.ENV === 'production',
    dsn: process.env.SENTRY_DSN
  })
}

Router.events.on('routeChangeComplete', () => {
  scrollTop()
})

export default class MyApp extends App {
  render () {
    const { Component, pageProps, err } = this.props
    const Layout = Component.Layout || DefaultLayout

    if (typeof window === 'undefined') {
      global.window = {} // Define um objeto `window` vazio como global
      global.navigator = {}
    }

    return (
      <>
        <Head>
          <meta name='viewport' content='width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover' />
          <title>Cobasi - Marketplace de Serviços</title>
        </Head>
        <RootProvider>
          <PaymentContextProvider>
            <ServiceScheduleContextProvider>
              <Layout>
                {/* https://github.com/vercel/next.js/issues/8592 */}
                <Component {...pageProps} err={err} />
              </Layout>
            </ServiceScheduleContextProvider>
          </PaymentContextProvider>
        </RootProvider>
        <GlobalStyle />
        <ToastContainer
          position='top-right'
          autoClose={5000}
          hideProgressBar={false}
          closeOnClick
        />
      </>
    )
  }
}
